module.exports = __webpack_public_path__ + "1a5743cd30c635a06248953cff6ad334.svg";